import { useState } from "react";
import MyMeetings from "./MyMeetings"; import SchedulingMeeting from "./SchedulingMeeting";
import { useData } from "../../core/contexts/DataContext";
import { MessagePopup } from "../../share/components/MessagePopup/MessagePopup";

const MeetingsTabs: React.FC = () => {
    const [activeTab, setActiveTab] = useState<"schedule" | "myMeetings">("schedule");

    const { message } = useData();

    return (

        <>
            {/* Message Popup */}
            {message && <MessagePopup message={message} />}

            <div className="w-full max-w-md mx-auto mt-6 border rounded shadow">
                {/* Tabs header */}
                <div className="nav-group-exhibitor">

                    <button
                        className={` ${activeTab === "schedule"
                            ? "active"
                            : "inactive"
                            }`}
                        onClick={() => setActiveTab("schedule")}
                    >
                        Schedule Meeting
                    </button>
                    <button
                        className={`${activeTab === "myMeetings"
                            ? "active"
                            : "inactive"
                            }`}
                        onClick={() => setActiveTab("myMeetings")}
                    >
                        My Meetings
                    </button>
                </div>

                {/* Tabs content */}

                <div className="content-container">
                    {activeTab === "schedule" && (
                        <SchedulingMeeting />
                    )}

                    {activeTab === "myMeetings" && (
                        <MyMeetings handleNavigateTo={event => setActiveTab(event)} />
                    )}
                </div>

            </div>
        </>
    );
};

export default MeetingsTabs;